<template>
  <div class="page-box">
    <div class="success-header">
      <div class="icon-circle">
        <span class="checkmark">✓</span>
      </div>
      <span class="success-text">支付成功</span>
    </div>

    <div v-if="promo" class="promo-list">
      <div v-if="promo.finderUserName" class="promo-btn channels" @click="goChannels">进入视频号</div>
    </div>

    <!-- <div class="order-detail">
      <div class="detail-title">支付订单详情</div>
      <div class="detail-item">支付金额：{{ amount }}元</div>
      <div class="detail-item">支付订单号：{{ outTradeNo }}</div>
      <div class="detail-item">支付状态：成功</div>
    </div>

    <div class="invoice-btn" @click="goInvoice">查看发票</div> -->
  </div>
</template>

<script>
  import { getChannelsConfig } from '@/api/api'

  export default {
    data() {
      return {
        // 微信点金计划 iframe URL 上拼接的 out_trade_no
        outTradeNo: '',
        amount: '',
        // 商户推广引流配置（由后端按订单号返回；为 null 时不显示视频号按钮）
        // 抖音/快手/小红书链接已改为在收银台 Wxpay 下单（点付款手势）时复制，本页仅负责视频号跳转
        promo: null,
        // 视频号引流 H5 落地页（点金计划 jumpOut 只支持 h5，故先跳此页，再由开放标签拉起小程序）
        // 仅传订单号（干净参数）；视频号参数由落地页按订单号再向后端获取，避免 URL 含编码字符导致签名失败
        channelsLandingPath: '/cashier/channels-launch'
      }
    },
    mounted() {
      let initData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE',
        height: 960
      }
      parent.postMessage(JSON.stringify(initData), '*')

      const link = location.href
      this.outTradeNo = this.getQueryString(link, 'out_trade_no')
      this.amount = this.getQueryString(link, 'amount') || '0'

      this.checkChannels()
    },
    methods: {
      getQueryString(path, name) {
        const reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
        if (reg.test(path)) {
          return unescape(RegExp.$2.replace(/\+/g, ' '))
        }
        return ''
      },
      goInvoice() {
        var mchData = {
          action: 'jumpOut',
          jumpOutUrl: location.origin + '/cashier/invoice'
        }
        parent.postMessage(JSON.stringify(mchData), '*')
      },
      checkChannels() {
        if (!this.outTradeNo) {
          return
        }
        getChannelsConfig(this.outTradeNo).then((data) => {
          // data 为 null 表示未配置任何推广项，不显示视频号按钮
          this.promo = data || null
        }).catch(() => {
          this.promo = null
        })
      },
      goChannels() {
        var jumpOutUrl = location.origin + this.channelsLandingPath +
          '?out_trade_no=' + encodeURIComponent(this.outTradeNo)
        var mchData = {
          action: 'jumpOut',
          jumpType: 'h5',
          jumpOutUrl: jumpOutUrl
        }
        parent.postMessage(JSON.stringify(mchData), '*')
      }
    }
  }
</script>

<style scoped>
  .page-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 120px 48px 80px;
    background: #f5f5f5;
    min-height: 100vh;
  }

  .success-header {
    display: flex;
    align-items: center;
    margin-bottom: 80px;
  }

  .icon-circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #07c160;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24px;
  }

  .checkmark {
    color: #fff;
    font-size: 48px;
    font-weight: bold;
  }

  .success-text {
    font-size: 44px;
    font-weight: 600;
    color: #333;
  }

  .order-detail {
    width: 100%;
    background: #fff;
    border-radius: 16px;
    padding: 40px 48px;
    margin-bottom: 40px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .detail-title {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin-bottom: 32px;
  }

  .detail-item {
    font-size: 28px;
    color: #666;
    line-height: 2;
  }

  .invoice-btn {
    width: 320px;
    height: 88px;
    background: #3b5bdb;
    border-radius: 8px;
    color: #fff;
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 40px;
  }

  .invoice-btn:active {
    opacity: 0.85;
  }

  .promo-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .promo-btn {
    width: 420px;
    height: 88px;
    border-radius: 44px;
    color: #fff;
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 28px;
  }

  .promo-btn:active {
    opacity: 0.85;
  }

  .promo-btn.channels {
    background: #07c160;
  }

  .copy-tip {
    width: 100%;
    background: #fff;
    border-radius: 16px;
    padding: 32px 36px;
    margin-top: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .copy-tip-title {
    font-size: 28px;
    color: #333;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .copy-line {
    font-size: 24px;
    color: #666;
    line-height: 1.7;
    word-break: break-all;
    margin-bottom: 12px;
  }

  .copy-platform {
    display: inline-block;
    background: #fff0f0;
    color: #e84335;
    font-size: 22px;
    border-radius: 6px;
    padding: 2px 12px;
    margin-right: 12px;
  }

  .toast {
    position: fixed;
    left: 50%;
    bottom: 120px;
    transform: translateX(-50%);
    max-width: 80%;
    padding: 20px 32px;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    font-size: 28px;
    border-radius: 12px;
    text-align: center;
    z-index: 100;
  }
</style>
